import {HttpContext} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IApi} from '@entities/api';
import {IBranchDossier} from '@shared/entities/branch-dossier/branch-dossier.interfaces';
import {SSR_TRANSFER} from '@shared/interceptors/ssr-transfer.interceptor';
import {ApiService} from '@shared/services';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BranchApi extends ApiService {
  public getBranch(branchId: string): Observable<IApi<IBranchDossier>> {
    return this.get<IApi<IBranchDossier>>(
      `${this.apiUrl}/subjects/${branchId}`,
      {context: new HttpContext().set(SSR_TRANSFER, true)}
    );
  }
}
